import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Shared from 'screens/shared';
import { _t } from 'utils';

export default () => {
  const [filters, setFilters] = useState({
    searchText: '',
  });

  const { groupUsers = [] } = useSelector((e) => e);

  const applyFilters = () => {
    let filteredItems = groupUsers;

    if (filters.searchText) {
      filteredItems = filteredItems
        .filter((item) => (
          (item.properties.firstname + item.properties.lastname).toLowerCase()
            .indexOf(filters.searchText.toLowerCase()) !== -1));
    }

    return filteredItems;
  };

  const setFilterValue = (value) => setFilters((e) => ({ ...e, ...value }));

  const filterFields = [
    {
      name: 'search',
      type: 'text',
      title: _t('Search'),
      onChange: (searchText) => setFilterValue({ searchText }),
    },
  ];

  return ([
    applyFilters(),
    <Shared.forms.Form
      fields={filterFields}
      fieldsValues={filters}
      isActionButtons={false}
    />,
  ]);
};
